import { render, staticRenderFns } from "./FloatingCartInfo.vue?vue&type=template&id=3c3dd0da&"
import script from "./FloatingCartInfo.vue?vue&type=script&lang=js&"
export * from "./FloatingCartInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports